import { g } from '../ability';

export default function defineLoggedOutAbilities(can) {
  can([g.VIEW], g.BILL);
  can([g.VIEW], g.BILL_ANNOTATION);
  can([g.VIEW], g.BILL_ANNOTATION_TOOLTIP);
  can([g.VIEW], g.SIDEBAR_SEARCH);
  can([g.VIEW], g.BILL_SEARCH);
}
